import { useEffect } from "react";

import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { FormHeader, NavigationButtons } from "common/lib/components";
import UploadDocumentsForm from "domains/liquidity/forms/UploadDocumentsForm";
import { useLiquiditySelector } from "domains/liquidity/store/liquidity.selectors";
import { useDocumentSelector } from "domains/documents/store/documents.selector";
import { documentsApiReducer } from "domains/documents/store/documents.api.reducer";
import { useHandlers } from "./useHandlers";

import "./AssetsDocumentsPage.scss";

const AssetsDocumentsPage = () => {
  const { t } = useTranslation([ "liquidity", "common" ]);
  const { LRId } = useParams();

  const { currentLiquidityRequest } = useLiquiditySelector();
  const { uploadingDocuments } = useDocumentSelector();
  const [ fetchLRDocuments ] = documentsApiReducer.useLazyFetchLRDocumentsQuery();

  const { onSubmit, onSkip } = useHandlers();

  useEffect(() => {
    if (!LRId || !currentLiquidityRequest?.account_id) return;

    fetchLRDocuments({ LRId, lrAccountId: currentLiquidityRequest.account_id });
  }, [ LRId, currentLiquidityRequest?.account_id ]);

  return (
    <>
      <FormHeader
        title={ t("Assets Documents Page.Step") }
        subtitle={ t("Assets Documents Page.Title") }
        hint={ t("Assets Documents Page.Info") }
      />

      <div className="ben-form-container ben-assets-documents-wrapper">
        <UploadDocumentsForm />

        <NavigationButtons
          disabled={ uploadingDocuments.length > 0 }
          onNext={ onSubmit }
          submitButtonText={ t("Submit", { ns: "common" }) }
          hideSkip={ false }
          onSkip={ onSkip }
        />

        <p className="assets-documents-bottom-info">{t("Assets Documents Page.Actions Info")}</p>
      </div>
    </>
  );
};

export default AssetsDocumentsPage;
